import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const MultivitaminForMen: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Multivitamin'}
      link="https://www.amazon.com/Nature-Made-Multi-Him-Tablets/dp/B004QHGPQQ"
    />
  </div>
)

export const MultivitaminForWomen: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Multivitamin'}
      link="https://www.amazon.com/Nature-Made-Multi-Her-Tablets/dp/B002ZWZJG6"
    />
  </div>
)

export const TapeMeasurer: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Tape measurer'}
      link="https://www.amazon.com/Smart-Tape-Measure-Body-Circumferences/dp/B082W886W9"
    />
  </div>
)
